import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import MapPage from "@/pages/MapPage";
// RosterPage retained but no longer routed; /roster now redirects to /dashboard.
// eslint-disable-next-line no-unused-vars
import RosterPage from "@/pages/RosterPage";
import TagManagerPage from "@/pages/TagManagerPage";
import LoginPage from "@/pages/LoginPage";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    // Still checking existing session — render nothing to avoid a flash.
    return (
      <div className="min-h-screen w-full bg-[#0a0a0a] flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-white/20 border-t-[#00e5ff] animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MapPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <MapPage />
                </ProtectedRoute>
              }
            />
            {/* Legacy route — kept as redirect for muscle memory */}
            <Route path="/roster" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/tags"
              element={
                <ProtectedRoute>
                  <TagManagerPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            fontFamily: "'JetBrains Mono', monospace",
          },
        }}
      />
    </div>
  );
}

export default App;
